/*
 * @Author: cn1994
 * @Date: 2023-10-18 10:33:25
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-23 20:02:50
 * @Description: file content
 */
export const jiaopei = {
  source:'jiaopei',
  quickActions: '快捷操作',
  school: '学校',
  allSchool: '全校',
  elseSchool: '校区',
  singleSchoole: '校',
  subject: '科目',
  currentSchool: '就读学校',
  // staff: '员工',
  student: '学员',
  // elseStudent: '学生',
  lecturer: '老师',
  teacher: '老师',
  mainTeacher: '主讲老师',
  assistantTeacher: '助教老师',
  class: '班级',
  singleClass: '班',
  allClass: '全班',
  newStudents: '招生',
  clue: '线索',
  sale: '销售',
  subjectManage: '科目主管',
  headmaster: '校长',
  textbook: '教材',
  shopAuth: '科目主管',
  wechatAuth: '学生/家长',
  msgSend:'家长通公众号的学生/家长',
  sjManage: '学科主管',
  mainCampus: '主校',
  joinCampus: '加盟校',
  subject2: '科目',
  subjectManageTitle: '教育科目',
  function:"独立手机官网、独立招生系统、独立积分兑奖系统",
  activity:"教材、课程",
  book: '课本',
  course: '教材',
  read: '阅读区',
  bookArea: '学校教材库',
  courseNumber: '有习题课文数/已发布数',
  text: '课文',
}

export default jiaopei
